import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GetParams,
  GetResponse,
  UnitOfMeasure,
  UnitOfMeasureCreate,
  UnitOfMeasureType,
  PostResponse,
  User,
  UserCreate,
} from '@app/shared';
import { convertGetParamsToHttpParams } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class UnitOfMeasureService {
  /** URLs principales relacionadas con UnitOfMeasures **/
  UnitOfMeasureUrl = environment.coreApiBaseUrl + '/api/unitofmeasure';
  UnitOfMeasureTypeUrl = environment.coreApiBaseUrl + '/api/unitofmeasure-type';
  userUrl = environment.identityApiBaseUrl + '/api/user';

  constructor(private http: HttpClient) {}

  /** Metodos de obtener/crear/actualizar/eliminar UnitOfMeasures **/
  getUnitOfMeasure(
    getParams: GetParams,
    accessToken?: string
  ): Observable<GetResponse> {
    let headers = new HttpHeaders();

    // Si el accessToken es proporcionado, agregamos el header Authorization
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    // Realizamos la petición GET con los parámetros y, si es necesario, con el token de autorización
    return this.http.get<GetResponse>(this.UnitOfMeasureUrl, {
      params: convertGetParamsToHttpParams(getParams),
      headers: headers, // Pasamos los headers
    });
  }

  createUnitOfMeasure(
    newUnitOfMeasure: UnitOfMeasureCreate
  ): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      this.UnitOfMeasureUrl,
      newUnitOfMeasure
    );
  }

  updateUnitOfMeasure(UnitOfMeasure: UnitOfMeasure): Observable<any> {
    return this.http.put(this.UnitOfMeasureUrl, UnitOfMeasure);
  }

  deleteUnitOfMeasure(UnitOfMeasuresIds: number[]): Observable<any> {
    return this.http.delete(this.UnitOfMeasureUrl, {
      body: { ids: UnitOfMeasuresIds },
    });
  }

  /** Metodos de obtener/crear/actualizar/eliminar UnitOfMeasureTypes **/
  getUnitOfMeasureType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.UnitOfMeasureTypeUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createUnitOfMeasureType(newUnitOfMeasureType: {
    name: string;
    isActive: boolean;
  }): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      this.UnitOfMeasureTypeUrl,
      newUnitOfMeasureType
    );
  }

  updateUnitOfMeasureType(
    UnitOfMeasureType: UnitOfMeasureType
  ): Observable<any> {
    return this.http.put(this.UnitOfMeasureTypeUrl, UnitOfMeasureType);
  }

  deleteUnitOfMeasureType(UnitOfMeasureTypesIds: number[]): Observable<any> {
    return this.http.delete(this.UnitOfMeasureTypeUrl, {
      body: { ids: UnitOfMeasureTypesIds },
    });
  }

  /** Metodos de obtener/crear/actualizar/eliminar User **/
  getUser(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.userUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createUser(newUser: UserCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.userUrl, newUser);
  }

  updateUser(User: User): Observable<any> {
    return this.http.put(this.userUrl, User);
  }

  deleteUser(desconsolidationsTypeIds: number[]): Observable<any> {
    return this.http.delete(this.userUrl, {
      body: { ids: desconsolidationsTypeIds },
    });
  }
}
